const reactDatePickerStyleOverrides = {
    '.react-datepicker': {
        fontFamily: 'Open Sans, sans-serif',
        fontSize: 'base',
        fontWeight: 'normal',
        padding: '4',
    },
    '.react-datepicker__day--highlighted, .react-datepicker__day--keyboard-selected, .react-datepicker__day--today.react-datepicker__day--highlighted.react-datepicker__day--keyboard-selected,.react-datepicker__day--today.react-datepicker__day--highlighted': {
        background: 'secondary.default',
        color: 'white',
        borderRadius: '50%',
        ':hover': {
            background: 'secondary.default',
            borderRadius: '50%',
        },
    },
    '>div, .react-datepicker, .react-datepicker__month': {
        width: '100%',
    },
    '.react-datepicker__month-container, .react-datepicker__children-container': {
        width: '100%',
    },
    '.react-datepicker__week, .react-datepicker__day-names': {
        display: 'flex',
        justifyContent: 'space-between',
    },
    '.react-datepicker__day-names': {
        paddingY: '1',
    },
    '.react-datepicker__month': {
        mt: '2',
        mb: '0',
        mx: '0',
    },
    '.react-datepicker__header': {
        background: 'white',
        border: 'none',
        padding: '0',
        '.react-datepicker__current-month': {
            fontWeight: 'semibold',
            fontSize: 'xl',
        },
    },
    '.react-datepicker__children-container': {
        display: 'flex',
        pl: '0',
        ml: '0',
        mb: '0',
    },
    '.react-datepicker__day--keyboard-selected:not(.react-datepicker__day--highlighted)': {
        background: 'white',
        color: 'black',
    },
    '.react-datepicker__day': {
        ':hover': {
            borderRadius: '50%',
        },
    },
    '.react-datepicker__day, .react-datepicker__day-name': {
        paddingX: '22px',
        paddingY: '2',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        margin: { base: '0' },
    },
    '.react-datepicker__day--keyboard-selected.react-datepicker__day--today,.react-datepicker__day--today': {
        background: 'primary.200',
        borderRadius: '50%',
        fontWeight: 'normal',
    },
    '.react-datepicker__day--disabled': {
        color: 'gray.600',
    },
};
export default reactDatePickerStyleOverrides;
